// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"DetailPage_pageTitle_cBx5m","icon":"DetailPage_icon_1KNTA","title":"DetailPage_title_RDHL7"};